import React, { Component} from 'react';
import ReactDOM from 'react-dom';
import { createStore, applyMiddleware } from 'redux';
import axios from 'axios';
import { Provider } from 'react-redux';
import ReduxPromise from 'redux-promise';
import Logger from 'redux-logger';
import { HashRouter, Route, Switch } from 'react-router-dom';
import { config } from './constants/domainConfig';
import { IntlProvider } from "react-intl";

// Styles
// Import Font Awesome Icons Set
import 'font-awesome/css/font-awesome.min.css';
// Import Simple Line Icons Set
import 'simple-line-icons/css/simple-line-icons.css';
// Temp fix for reactstrap
import '../scss/core/_dropdown-menu-right.scss';
// Import Swiper css
import 'react-id-swiper/src/styles/scss/swiper.scss';
// Import Simplebar css
import 'simplebar/dist/simplebar.css';
// Import Main styles for this application
import '../scss/style.scss';
// Import Videojs style
import 'video.js/dist/video-js.min.css';
// Import Videojs Panaroma style
import 'videojs-panorama/dist/videojs-panorama.min.css';
import 'react-responsive-modal/styles.css'
// Views
import App from './containers/App';
import RootReducer from './reducers/index';

// const persistedState = (typeof sessionStorage.getItem('mobiotv') != "undefined") ? JSON.parse(sessionStorage.getItem('mobiotv')) : null;
//localisation
import { addLocaleData } from "react-intl";
import locale_en from 'react-intl/locale-data/en';
import locale_fr from 'react-intl/locale-data/fr';
import locale_be from 'react-intl/locale-data/be';
import locale_tr from 'react-intl/locale-data/tr';
import locale_pt from 'react-intl/locale-data/pt';
import locale_no from 'react-intl/locale-data/no';
import locale_ar from "react-intl/locale-data/ar";
import locale_de from "react-intl/locale-data/de";
import locale_cy from "react-intl/locale-data/cy";
import locale_ee from "react-intl/locale-data/ee";
import locale_th from "react-intl/locale-data/th";
import locale_es from "react-intl/locale-data/es";
import locale_it from "react-intl/locale-data/it";
import locale_el from "react-intl/locale-data/el";
import locale_id from "react-intl/locale-data/id";
import locale_si from "react-intl/locale-data/si"
import locale_pl from "react-intl/locale-data/pl"

addLocaleData([
    ...locale_en,
    ...locale_fr,
    ...locale_be,
    ...locale_tr,
    ...locale_pt,
    ...locale_no,
    ...locale_ar,
    ...locale_de,
    ...locale_cy,
    ...locale_ee,
    ...locale_th,
    ...locale_es,
    ...locale_it,
    ...locale_el,
    ...locale_id,
    ...locale_si,
    ...locale_pl
]);

import messages_en from "./translations/en.json";
import messages_fr from "./translations/fr.json";
import messages_be from "./translations/be.json";
import messages_tr from "./translations/tr.json";
import messages_pt from "./translations/pt.json";
import messages_no from "./translations/no.json";
import messages_ar from "./translations/ar.json";
import messages_de from "./translations/de.json";
import messages_cy from "./translations/cy.json";
import messages_ee from "./translations/ee.json";
import messages_th from "./translations/th.json";
import messages_es from "./translations/es.json";
import messages_it from "./translations/it.json";
import messages_el from "./translations/el.json";
import messages_id from "./translations/id.json";
import messages_si from "./translations/si.json";
import messages_pl from "./translations/pl.json"

const messages = {
    'en': messages_en,
    'fr': messages_fr,
    'be': messages_be,
    'tr': messages_tr,
    'ar': messages_ar, 
    'pt': messages_pt,
    'no': messages_no,
    'de': messages_de,
    'cy': messages_cy,
    'ee': messages_ee,
    'th': messages_th,
    'es': messages_es,
    'it': messages_it,
    'el': messages_el,
    'id': messages_id,
    "si": messages_si,
    "pl": messages_pl

};

let language = config.lang;

const persistedState = (typeof sessionStorage.getItem('mobiotv') != "undefined") ? JSON.parse(sessionStorage.getItem('mobiotv')) : null;

const connectWithReduxMiddleWare = applyMiddleware(ReduxPromise)(createStore);
// const store = connectWithReduxMiddleWare(RootReducer);
const store = (persistedState != null)? connectWithReduxMiddleWare(RootReducer, persistedState): connectWithReduxMiddleWare(RootReducer);

store.subscribe(() => {
    if(store.getState().AccountReducer.interests.length>0 ){
        sessionStorage.setItem('mobiotv', JSON.stringify(store.getState()));
    }
});

export const addToken = (function() {
    axios.defaults.timeout = 20000;
    // let token = store.getState().WelcomeReducer.token;
    let token;
    if(sessionStorage.getItem('authorized')){
        token= JSON.parse(sessionStorage.getItem('authorized')).token;
    }
    if (token) {
        axios.defaults.headers.common['authorization'] = token;
    } else {
        axios.defaults.headers.common['authorization'] = null;
        /*if setting null does not remove `Authorization` header then try
         delete axios.defaults.headers.common['Authorization'];
         */
    }
})();

class LangWrapper extends Component {

    componentWillMount(){
        const h = document.querySelector("html");
        h.setAttribute("lang", config.lang);
        if(config.dir == 'rtl') h.setAttribute("dir", "rtl");
        
    }
    changeLang(event) {
        if (event == 'ar') {
            config.lang = 'ar';
            const h = document.querySelector("html");
            h.setAttribute("dir", "rtl");
            h.setAttribute("lang", "ar");
        }else if(event=='be') {
            config.lang = 'be';
            const h = document.querySelector("html");
            h.setAttribute("lang", "be");
        }
        else if(event=='fr') {
            config.lang = 'fr';
            const h = document.querySelector("html");
            h.setAttribute("lang", "fr");
        }
        else if(event=='de') {
            config.lang = 'de';
            const h = document.querySelector("html");
            h.setAttribute("lang", "de");
        }
        else if(event=='it'){
            config.lang = 'it'
            const h = document.querySelector("html");
            h.setAttribute("lang", "it");
        }
        else if(event=='id'){
            config.lang = 'id'
            const h = document.querySelector("html");
            h.setAttribute("lang", "id");
        }
        else {
            config.lang = 'en';
            const h = document.querySelector("html");
            h.setAttribute("dir", "ltr");
            h.setAttribute("lang", "en");
        }
        this.setState({})
    };

    render() {
        return (
            <IntlProvider locale={config.lang} messages={messages[config.lang]}>
                <HashRouter>
                    <Switch>
                        <App changeLang={this.changeLang.bind(this)} currentLang={config.lang}/>
                    </Switch>
                </HashRouter>
            </IntlProvider>)
    }

}

ReactDOM.render(
    <Provider store={store}>
        <LangWrapper />
    </Provider>,
    document.getElementById('root'));






// WEBPACK FOOTER //
// ./src/index.js